import { baseEnvironment, IEnvironment } from './environment.base';
import merge from 'deepmerge';

const apiServiceUrl =
  window._API_URLS_?.apiServiceUrl && window._API_URLS_?.apiServiceUrl.length > 0
    ? window._API_URLS_?.apiServiceUrl
    : 'https://dev-api.fluxonos.de';

const environmentDevelopment: IEnvironment = {
  stage: 'development',
  production: false,
  apiUrl: apiServiceUrl,
  features: {
    userModule: {},
    manufacturerModule: {},
    customerModule: {},
    energySupplierModule: {},
    gridOperatorModule: {}
  }
};

export const environment: IEnvironment = merge(baseEnvironment, environmentDevelopment);
